module.exports = __webpack_public_path__ + "static/img/互联网医院建设-商务.943615e7.png";